import { render, staticRenderFns } from "./PublishmentPreview.vue?vue&type=template&id=309a884c&"
import script from "./PublishmentPreview.vue?vue&type=script&lang=ts&"
export * from "./PublishmentPreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports